import { createSlice } from '@reduxjs/toolkit';
import { PAYMENT_GATEWAY, PAYMENT_GATEWAY_PROPERTY } from '../constants';

export const eventsSlice = createSlice({
  name: 'events',
  initialState: {
    eventsData: {},
    analyticsData: {},
  },
  reducers: {
    setEventData: (state, action) => {
      Object.assign(state.eventsData, action.payload);
    },
    clearStripeFromEventsData: (state) => {
      const { stripe_account_name: _s, ...rest } = state.eventsData as Record<string, unknown>;
      state.eventsData = {
        ...rest,
        [PAYMENT_GATEWAY_PROPERTY]: PAYMENT_GATEWAY.BRAINTREE,
      } as typeof state.eventsData;
    },
    setAnalyticsData: (state, action) => {
      Object.assign(state.analyticsData, action.payload);
    },
  },
});

export const { setEventData, setAnalyticsData, clearStripeFromEventsData } = eventsSlice.actions;

export const selectEventsData = (state: any) => state.events.eventsData;
export const selectAnalyticsData = (state: any) => state.events.analyticsData;

export default eventsSlice.reducer;
